function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MuiFormControl from '@material-ui/core/FormControl';
import propTypeComponent from '@signal/prop-types/component';
import FormGroup from '../FormGroup';
import FormLabel from '../FormLabel';
import { Legend } from './styles';
export var FormControlGroup = /*#__PURE__*/memo(function (props) {
  var GroupComponent = props.component,
      LabelProps = props.LabelProps,
      label = props.label,
      rest = _objectWithoutProperties(props, ["component", "LabelProps", "label"]);

  return /*#__PURE__*/React.createElement(MuiFormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, Object.assign({
    gutterBottom: true
  }, LabelProps), label), /*#__PURE__*/React.createElement(GroupComponent, Object.assign({
    label: label
  }, rest)));
});
export var propTypes = {
  component: propTypeComponent.isRequired,
  label: PropTypes.string,
  LabelProps: PropTypes.object
};
FormControlGroup.propTypes = propTypes;
FormControlGroup.defaultProps = {
  component: FormGroup,
  LabelProps: {
    component: Legend
  }
};
export default FormControlGroup;